import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const KeyPoints = () => {
    // const keyPoints = AnalysisResults[0]["toc_analysis"]; 
    const [summary, setSummary] = useState("default");
    const [list, setList] = useState([]);

    const { analysis } = useSelector((state) => state.tc);
    const { isAuth, user } = useSelector((state) => state.user);

    useEffect(() => {
        if (isAuth && user && user.preferences) {
          const textSize = user.preferences.textSize;
    
          switch (textSize) {
            case 0: // Small
                document.documentElement.style.setProperty('--analysis-font-size-header', '0.8vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '10px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '0.8vw');
                break;
            case 1: // Medium (default)
                document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
                break;
            case 2: // Large
                document.documentElement.style.setProperty('--analysis-font-size-header', '1.3vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '16px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1.5vw');
                break;
            default:
              break;
          }
        } else if (!isAuth) { 
            document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
            document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
            document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
          }
        }, [user, isAuth]);

    useEffect(() => {
        if (analysis){
            const keypts = JSON.parse(analysis.keypoints);
            if (keypts.hasOwnProperty('toc_analysis')){
                if (keypts.toc_analysis.hasOwnProperty('summary')){
                    setSummary(keypts.toc_analysis.summary);
                } else {
                    setSummary("No summary available");
                }
                if (keypts.toc_analysis.hasOwnProperty('sections')){
                    setList(keypts.toc_analysis.sections);
                } else {
                    setList([]);
                }
            } else {
                setSummary("No summary available");
                setList([]);
            }
            // setList([]);
        }
    }, [analysis]);

    return (
        <div className="keyPointsResults">
            <p className="resultsExplanation">{"The document covers the following key points:"}</p>
            <div key="showResults" className="keyPointsList">
                <p id="summary">{summary}</p>
                {list.map( (element, index) => {
                    /* Not sure if keys are all reset. Might be a problem if two documents are uploaded. Could add the document id to the key.*/
                    return (<li key={index} className={"keyPointsOutput resultsList"}>
                        {element.title}: {element.content}
                        <ul>
                        {element.highlights !== undefined && element.highlights.map((el) => {
                            return (<li>{el}</li>)
                        })}
                        </ul>    
                    </li>)
                })}
            </div>
        </div>
    );
}

export default KeyPoints;